<p *ngIf="valorAntes == valorDepois" title="Não alterado pelo aditivo">
    {{conteudoAntes}}
</p>
<p *ngIf="valorAntes != valorDepois">
    <span class="text-danger" title="Antes do Aditivo"><i class="fa fa-arrow-left me-1"
                                                          aria-hidden="true"></i>{{conteudoAntes}}</span><br/>
    <span class="text-success" title="Depois do Aditivo"><i class="fa fa-arrow-right me-1"
                                                            aria-hidden="true"></i>{{conteudoDepois}}</span>
</p>
